const { datadog } = window.tv2 || {};
const { enabled, application } = datadog || {};
const { isTv2Prod, isTv2Staging } = window.tv2?.utils || {};
const env = isTv2Prod ? 'prod' : isTv2Staging ? 'stage' : 'dev';
if (enabled) {
    window.tv2.utils.loadScript('https://www.datadoghq-browser-agent.com/eu1/v6/datadog-logs.js', () => {
        if (window.DD_LOGS) {
            window.DD_LOGS.init({
                clientToken: 'pubf84b18a9d069549dc9823f728a6b7926',
                site: 'datadoghq.eu',
                forwardErrorsToLogs: false,
                sessionSampleRate: 0,
                // eslint-disable-next-line no-bitwise
                service: application || 'tv2dk-fronts',
                env: env,
                version: '1.0.0',
            });
            window.DD_LOGS.setGlobalContextProperty('team', 'tv2dk-fronts');
        }
    });
}
export {};
//# sourceMappingURL=datadog.js.map